import React, { FC } from 'react'
import style from './Tag.module.scss'
import { TagProps } from './types'
import classnames from 'classnames'
import Icon from '../Icon'
import { iconName, colour } from '../Icon/types'

const Tag: FC<TagProps> = ({ position = 'left', isOpen = false, content }) => {

  const getArrowIcon = (position: TagProps['position']) => {

    if (position === 'left') return <Icon name={iconName.caretRight} colour={colour.brightTALK} />
    if (position === 'right') return <Icon name={iconName.caretLeft} colour={colour.brightTALK} />
    if (position === 'top') return <Icon name={iconName.caretDown} colour={colour.brightTALK} />
    if (position === 'bottom') return <Icon name={iconName.caretUp} colour={colour.brightTALK} />

  }

  const tagClasses = classnames(
    style['tag'], {
      [style['tag--left']]: position === 'left',
      [style['tag--right']]: position === 'right',
      [style['tag--top']]: position === 'top',
      [style['tag--bottom']]: position === 'bottom',
      [style['tag--hide']]: !isOpen
    }
  )
  const pointerClasses = classnames(
    style['tag-pointer'], {
      [style['tag-pointer--horizontal']]: position === 'left' || position === 'right',
      [style['tag-pointer--vertical']]: position === 'top' || position === 'bottom'
    }
  )

  return <div className={tagClasses} data-bdd='tag' >
    {position === 'left' || position === 'top' ? <div data-bdd='tag-content' className={style['content']}>{content}</div> : ''}
    <div className={pointerClasses} data-bdd='tag-pointer' >{getArrowIcon(position)}</div>
    {position === 'right' || position === 'bottom' ? <div data-bdd='tag-content' className={style['content']}>{content}</div> : ''}
  </div>

}

export default Tag
